class Misc {

    constructor() {
        this.disableScrollHint = false;
    }

    initScrollHint(hideOnScroll) {
        window.setTimeout(() => {
            if(!this.disableScrollHint) {
                this.scrollHint = $('.jsScrollHint');
                this.scrollHint
                    .removeClass('d-none')
                    .addClass('animated fadeInDown');
                this.scrollHint.click(() => {
                    $.fn.fullpage.moveSectionDown();
                });
            }
        }, 5000);

        if(hideOnScroll) {
            $(window).scroll(() => {
                this.disableScrollHint = true;
                this.hideScrollHint();
            });
        }
    }

    hideScrollHint() {
        this.disableScrollHint = true;
        if(this.scrollHint) {
            this.scrollHint
                .addClass('animated fadeOut');
        }
    }

    initNextProject() {
        const scrollUpThreshold = 100;
        this.nextProject = $('.jsNextProject');
        $(window).on('scroll', (e) => {
            let scrollTop = $(e.currentTarget).scrollTop();

            // if end of page is reached
            if(scrollTop + scrollUpThreshold >= $(document).height() - $(e.currentTarget).height()) {
                this.nextProject
                    .removeClass('d-none fadeOut')
                    .addClass('animated fadeInDown');
            } else {
                this.nextProject
                    .addClass('animated fadeOut');
            }
        });
    }

    scrollOnCollapse() {
        $('.jsCollapse').each((index, el) => {
            $(el).on('show.bs.collapse', () => {
                let scrollTo = ResponsiveBootstrapToolkit.is('>=md') ? $(el).prev('a').offset().top - Navigation.navtrigger.position().top : $(el).prev('a').offset().top - 16;
                Layout.scrollTo(scrollTo);
                $(el).prev('a').blur();
            })

            $(el).on('hide.bs.collapse', () => {
                $(el).prev('a').blur();
            });
        });
    }
}

export default Misc;